import { useContext } from 'react';
import { currentPrimaryDimensionContext } from './context';
export var useCurrentPrimaryDimension = function () {
    var currentPrimaryDimension = useContext(currentPrimaryDimensionContext);
    return currentPrimaryDimension;
};
